// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1OtCk","footer":"ChangeClinic_footer__cWgn6"};